let loaded = 0;
addEventListener("load", (event) => {
    document.body.classList.remove('loading');
});